module.exports = __webpack_public_path__ + "static/media/hornbill.69a6de0d.svg";